"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareResultFragment = exports.nevadaGenesysNoToSystemFileIdQuery = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.nevadaGenesysNoToSystemFileIdQuery = (0, graphql_tag_1.default) `
  query NevadaTestGenesysNoToSystemFile($genesysNo: Float!) {
    user {
      genesysNumberToFile(genesysNo: $genesysNo) {
        id
        name
        systemTypeId
        systems {
          id
          revisionNo
        }
      }
    }
  }
`;
exports.compareResultFragment = (0, graphql_tag_1.default) `
  fragment CompareResults on NevadaResultType {
    hasError
    errorCode
    errorText
    warnings
    compareResult {
      components {
        name
        operatingCases {
          name
          refSystem
          testSystem
        }
        price {
          name
          refSystem
          testSystem
        }
        productId
        properties {
          refSystem
          testSystem
        }
        specifications {
          refSystem
          testSystem
        }
      }
    }
  }
`;
//# sourceMappingURL=queries.js.map